import './styles.css';
import PageTitle from '../../../components/Accessibility/PageTitle';
import DefaultButton from '../../../components/Accessibility/DefaultButton';
import DefaultText from '../../../components/Accessibility/DefaultText';
import VoltarButton from '../../../components/Accessibility/VoltarButton';
import { useNavigate } from 'react-router-dom';

const AgendamentosMaisDetalhes: React.FC = () => {

  const navigate = useNavigate();

  return (
      <div className='page-container'>

        <PageTitle text="Como funciona o atendimento online com o psicoterapeuta?" />

        <div className="max-width-660 flex-col gap-20">
          <DefaultText text="É uma forma inovadora de receber atendimento psicológico. O atendimento psicológico online é um espaço onde você será ouvido(a), acolhido(a) e poderá ter ajuda clínica em caso de sofrimento. Assim, você recebe ajuda no momento em que mais precisa. É imediato, preciso e inclusivo para o momento atual, sem precisar sair de casa."/>
          <DefaultText text="Você será acolhido(a) e, junto ao psicoterapeuta, vai construir o seu projeto terapêutico." />
          <DefaultText text="Após fazer a sua avaliação, você terá 7 dias para agendar sua consulta." />
        </div>
        
        <DefaultButton text="Realizar Agendamento" onClick={() => { navigate('/saudeBemEstar/unimedAcolhe/agendamentos/agendar') }} /> 

        <VoltarButton onClick={() => { navigate('/saudeBemEstar/unimedAcolhe/agendamentos') }}/>

      </div>
  )
}

export default AgendamentosMaisDetalhes;